export const EMPTY_VALUE = '-1';
export const DATE_TIME_TIMEZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const SHORT_DATE_FORMAT = 'YYYY-MM-DD';
export const REQUEST_DATE_FORMAT = 'DD-MM-YYYY';
export const LONG_DATE_FORMAT = 'DD MMMM YYYY';
export const SELECTED_DATE_PICKER_VALUE_TYPE = 'This school year';
export const GOLD_CERTIFICATE_TYPE = '3';
export const SILVER_CERTIFICATE_TYPE = '2';
export const BRONZE_CERTIFICATE_TYPE = '1';

export const CERTIFICATE_TYPES = [GOLD_CERTIFICATE_TYPE, SILVER_CERTIFICATE_TYPE, BRONZE_CERTIFICATE_TYPE];

export const DOWNLOAD_CERTIFICATES_URL_PATH = 'api/v1/certificates/export';
export const DOWNLOAD_CERTIFICATES_BY_TYPES_URL_PATH = 'api/v1/certificates/types/{type}/export';



// WEBPACK FOOTER //
// ./app/containers/download-certificates/constants.js